import React, { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import { Sortable, MultiDrag } from 'sortablejs';
import { useMutation, useQueryClient } from 'react-query';
import { MdFiberManualRecord, MdEdit } from 'react-icons/md';
import { RiEyeLine, RiEyeCloseLine } from 'react-icons/ri';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Proptypes from 'prop-types';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import { useGlobalData } from '../../context/globalData';
import { deleteMessage, editMessage, updateMessageStatus } from '../../api/ticker';
import useOnUpdate from '../../hooks/useOnUpdate';
import MenuContext from '../../layouts/MenuContext';
import { CancelSortPlugin } from '../../utils/cancelSortablejs';

Sortable.mount(new MultiDrag(), CancelSortPlugin());
function MessagesList(props) {
  const { globalData } = useGlobalData();
  const queryClient = useQueryClient();
  const { messages, disableSort, options, setSideMenu, setMessageData, setNotifications, carousel, type, showOkPopup } = props;
  // const messagePosition = globalData?.messages.filter((msg) => msg.carouselID === carousel.carouselID && msg.isLive).length;
  const [selectedIndex, setSelectedIndex] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [holdControl, setHoldControl] = useState(false);
  const [holdShift, setHoldShift] = useState(false);
  const [system, setSystem] = useState(globalData.tab?.systemRuning);
  const [list, setList] = useState(messages);

  const { mutate: updateStatus } = useMutation((data) => updateMessageStatus(data), {
    onSuccess: () => {
      queryClient.invalidateQueries('tickerData');
      queryClient.invalidateQueries('synchroDB');
      queryClient.invalidateQueries('xmlData');
    },
    onError: (err) => {
      console.log('err', err);
    },
  });

  const { mutate: handleDelete } = useMutation((id) => deleteMessage(id), {
    onSuccess: () => {
      queryClient.invalidateQueries('tickerData');
      queryClient.invalidateQueries('synchroDB');
      queryClient.invalidateQueries('xmlData');
    },
  });

  const { mutate: updateMessage } = useMutation((data) => editMessage(data, data.messageID), {
    onSuccess: () => {
      queryClient.invalidateQueries('tickerData');
      queryClient.invalidateQueries('synchroDB');
      queryClient.invalidateQueries('xmlData');
    },
  });

  const handleKeyDownDelete = (event) => {
    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (!carousel.isActive || (type === 'antenne' && list.length - selectedItems.length > 0) || type !== 'antenne') {
        for (let index = 0; index < selectedItems.length; index++) {
          const id = selectedItems[index];
          handleDelete(id);
        }
      } else {
        showOkPopup();
      }
    }
  };

  useOnUpdate(() => {
    setSystem(globalData.tab?.systemRuning);
  }, [globalData.tab]);

  useOnUpdate(() => {
    setList(messages);
  }, [messages]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Control') {
        setHoldControl(true);
      }
      if (e.key === 'Shift') {
        setHoldShift(true);
      }
    };
    const onKeyUp = (e) => {
      if (e.key === 'Control') {
        setHoldControl(false);
      }
      if (e.key === 'Shift') {
        setHoldShift(false);
      }
    };
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('keyup', onKeyUp);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  const handleSort = (event) => {
    const destList = [...event.to.childNodes].map((obj) => parseInt(obj.attributes['data-id'].value));
    const fromList = [...event.from.childNodes].map((obj) => parseInt(obj.attributes['data-id'].value));

    if (carousel.isActive && fromList.length === 0 && event.to.id === 'offline') {
      showOkPopup();
    } else {
      destList.forEach((id, index) => {
        if (event.to.id === 'antenne') {
          updateStatus({ messageID: id, isLive: true, position: index });
        } else if (event.to.id === 'offline') {
          updateStatus({ messageID: id, isLive: false, position: index });
        }
      });
      fromList.forEach((id, index) => {
        if (event.from.id === 'antenne') {
          updateStatus({ messageID: id, isLive: true, position: index });
        }
      });
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
          mouseX: event.clientX + 2,
          mouseY: event.clientY - 6,
        }
        : null,
    );
  };


  return (
    <ClickAwayListener onClickAway={() => setSelectedItems([])}>
      <List style={{ pointerEvents: holdShift ? 'none' : 'auto' }} component="ul" className="relative" disablePadding >

        <div style={{
          position: 'relative',
          border: '1px',
           height: '100%'
          //  cursor: move;
          //  &:hover {
          //    //background: #eeeeee;
          // 
        }}>
          <ReactSortable
            multiDrag
            swap
            className="h-full"
            group="messageList"
            multiDragKey="Control"
            id={type}
            list={[...list]}
            setList={setList}
            disabled={disableSort}
            delay={20}
            onChoose={(e) => {
              setSelectedItems((prev) => {
                const alreadySelected = prev.filter((msg) => msg === parseInt(e.item.attributes['data-id'].value))[0];
                if (!holdControl) {
                  return [parseInt(e.item.attributes['data-id'].value)];
                }
                if (alreadySelected) {
                  return [
                    ...e.items
                      .map((item) => parseInt(item.attributes['data-id'].value))
                      .filter((item) => item !== parseInt(e.item.attributes['data-id'].value)),
                  ];
                }
                return [
                  ...e.items.map((item) => parseInt(item.attributes['data-id'].value)),
                  parseInt(e.item.attributes['data-id'].value),
                ];
              });

              const currentMessage = list.filter((msg) => msg.messageID === parseInt(e.item.attributes['data-id'].value))[0];
              setSelectedIndex(currentMessage);
            }}
            onAdd={(e) => {
              handleSort(e);
            }}
            onUpdate={(e) => {
              handleSort(e);
            }}
          >

            {list.map((message) => {
              const messageIsSelected = selectedItems.filter((msgID) => msgID === message.messageID)[0];
            
              
              return (
                <li
                  key={message.messageID}
                  className={`listeCtn ${messageIsSelected ? 'Mui-selected' : ''}`}
                  template={message.templateLabel}
                >
                  <div
                    onContextMenu={(e) => {
                      handleContextMenu(e);
                      setSelectedIndex(message);
                      setSelectedItems([message.messageID]);
                    }}
                  >
                    <ListItemButton visible={message.isVisible} onKeyDown={(e) => handleKeyDownDelete(e, message)} onDoubleClick={() => {
                      setSideMenu(true);
                      setMessageData(message);
                    }}>
                      <div className="grid grid-cols-1 w-full items-center p-2 message gap-2">
                        {options.antenne && (
                          <>
                            <div className="flex space-x-2 col-start-1 justify-self-center">
                              {/* <button
                              type="button"
                              className="danger rotate-180"
                              onClick={() => {
                                updateMessage({ ...message, isLive: false, position: 0 });
                              }}
                              title="Retirer le message de l'antenne"
                            >
                              <MdKeyboardTab size={20} />
                            </button> */}
                              <button
                                type="button"
                                className="focus"
                                onClick={() => updateMessage({ ...message, isVisible: !message.isVisible })}
                                title={message.isVisible ? "Désactiver le message de l'antenne" : "Activer le message de l'antenne"}
                              >
                                {message.isVisible ? <RiEyeLine size={20} /> : <RiEyeCloseLine size={20} />}
                              </button>
                              <button
                                type="button"
                                className="focus"
                                onClick={() => {
                                  setSideMenu(true);
                                  setMessageData(message);
                                }}
                                title="Editer le message"
                              >
                                <MdEdit />
                              </button>
                            </div>
                            {message.messageID === carousel[`currentMessageID_${system}`] && (
                              <MdFiberManualRecord
                                className="justify-self-center"
                                title="Message actif"
                                color="var(--on)"
                                size={22}
                              />
                            )}
                            <div className="messageCount whitespace-nowrap col-start-1" title={message[`counter_${system}`]}>
                              {message[`counter_${system}`] !== undefined ? message[`counter_${system}`] : '-'}
                            </div>
                            {/* <div
                              className="messageDate whitespace-nowrap col-start-1">
                              {formatDate(message.createdDate)}
                            </div> */}
                          </>
                        )}
                        {/* {!options.antenne && (<div className="messageTitle whitespace-nowrap col-start-1" title={message.templateLabel?.toUpperCase()}>
                          {message.templateLabel.toUpperCase()}
                        </div>)} */}
                        <div
                          dir={globalData?.tab?.label === 'ar' ? 'rtl' : 'ltr'}
                          style={globalData?.tab?.label === 'ar' ? { textAlign: 'right' } : { textAlign: 'left' }}
                          className={`messageContent whitespace-nowrap col-start-1 ${message.carouselID}`}
                          title={message.content}
                        >
                          {message.templateType === 4 ? message.templateLabel.toUpperCase() : message.content }
                        </div>
                        {options.play && carousel.carouselID !== 3 && (
                          <div className="flex space-x-2 col-start-2 justify-self-end">
                            <button
                              type="button"
                              className="focus"
                              onClick={() => {
                                setSideMenu(true);
                                setMessageData(message);
                              }}
                              title="Editer le message"
                            >
                              <MdEdit size={15} />
                            </button>
                            {/* <button
                            type="button"
                            className="focus"
                            onClick={() => updateMessage({ ...message, isLive: true, position: messagePosition })}
                            title="Mettre le message à l'antenne"
                          >
                            <MdKeyboardTab size={18} />
                          </button> */}
                          </div>
                        )}

                      </div>
                    </ListItemButton>
                  </div>

                  <Divider sx={{ borderColor: 'rgba(206, 206, 206, 0.1)' }} />
                </li>

              );
            })}
            
          </ReactSortable>
        </div>
        {contextMenu && (
          <MenuContext
            contextMenu={contextMenu}
            list={list}
            selectedItems={selectedItems}
            setContextMenu={setContextMenu}
            selectedMessage={selectedIndex}
            setNotifications={setNotifications}
            carousel={carousel}
            handleDelete={handleDelete}
            contextName={type}
            showOkPopup={showOkPopup}
          />
        )}

      </List>

    </ClickAwayListener>
  );
}

MessagesList.propTypes = {
  messages: Proptypes.array,
  type: Proptypes.string,
  setNotifications: Proptypes.func,
  disableSort: Proptypes.bool,
  options: Proptypes.object,
  carousel: Proptypes.object,
  setSideMenu: Proptypes.func,
  setMessageData: Proptypes.func,
  showOkPopup: Proptypes.func
};

MessagesList.defaultProps = {
  messages: [],
  type: '',
  setNotifications: () => { },
  disableSort: false,
  options: {},
  carousel: {},
  setSideMenu: () => { },
  setMessageData: () => { },
  showOkPopup: () => { }
};

export default MessagesList;
